import { isEmailValid, isMobileValid } from '@mobi/account/Utils/validation'

import { range } from '@mobi/utils/array'

export const NAME_REGEX = /^[A-Z]([A-Z '-]*[A-Z])?$/i

export const ALPHANUMERIC_REGEX = /[^a-z0-9]/gi

export const NAME_VALIDATION_MESSAGE =
  'Please enter a valid name, containing only letters, spaces, apostrophes, and hyphens.'
export const REQUIRED_VALIDATION_MESSAGE = 'This field is required.'
export const MEDICARE_CARD_NUMBER_VALIDATION_MESSAGE = 'Enter 10 digits only.'
export const MEDICARE_REFERENCE_NUMBER_VALIDATION_MESSAGE = 'Enter 1 digit only.'
export const REQUIRED_STREET_NUMBER =
  'We require a street number. Please try another address or enter your address manually'

export function getRequiredValidationMessage(value: string | null | undefined) {
  return !value ? REQUIRED_VALIDATION_MESSAGE : ''
}

export function getRequiredStreetNumberValidationMessage(streetNumber: string | null | undefined) {
  return !streetNumber ? REQUIRED_STREET_NUMBER : ''
}

// Personal details validation

export function isValidName(name: string, allowBlank = false): boolean {
  if (!name) {
    return allowBlank
  }

  return NAME_REGEX.test(name)
}

export function getNameValidationMessage(name: string | null, allowBlank = false) {
  if (name === '' || name === null) return allowBlank ? '' : REQUIRED_VALIDATION_MESSAGE

  if (!isValidName(name, allowBlank)) return NAME_VALIDATION_MESSAGE

  return ''
}

export function getEmailValidationMessage(enteredText: string) {
  if (enteredText === '') return REQUIRED_VALIDATION_MESSAGE

  if (!isEmailValid(enteredText)) {
    return 'Please enter a proper email address.'
  }

  return ''
}

export function getFormattedMobile(enteredText: string) {
  return enteredText.replace(/[\D]/gi, '')
}

export function getMobileValidationMessage(enteredText: string) {
  if (enteredText === '') return REQUIRED_VALIDATION_MESSAGE

  if (!isMobileValid(enteredText)) {
    return 'Please enter a valid Australian mobile number.'
  }

  return ''
}

// Medicare validation

export const medicareExpiryNext10Years = () => {
  const thisYear = new Date().getFullYear()
  return range(thisYear, thisYear + 10)
}

export function validateCardNumber(value: string | null | undefined) {
  if (!value) return REQUIRED_VALIDATION_MESSAGE
  if (!/^[0-9]{10}$/.test(value)) return MEDICARE_CARD_NUMBER_VALIDATION_MESSAGE
  return ''
}

export function validateReferenceNumber(value: string | null | undefined) {
  if (!value) return REQUIRED_VALIDATION_MESSAGE
  if (!/^[0-9]{1}$/.test(value)) return MEDICARE_REFERENCE_NUMBER_VALIDATION_MESSAGE
  return ''
}

export function validateExpiryDay(day: number | undefined, isGreenMedicareCardSelected: boolean) {
  return isGreenMedicareCardSelected ? '' : day == null ? REQUIRED_VALIDATION_MESSAGE : ''
}

// Deposit limit validation

export const DEPOSIT_LIMIT_MIN = 1
export const DEPOSIT_LIMIT_MAX = 99999
export const DEPOSIT_LIMIT_VALIDATION_MESSAGE = `Please enter a whole number between ${DEPOSIT_LIMIT_MIN} and ${DEPOSIT_LIMIT_MAX}.`

export function validateDepositLimitAmount(value: string): string {
  const num = Number(value)
  if (
    isNaN(num) ||
    !Number.isInteger(num) ||
    num < DEPOSIT_LIMIT_MIN ||
    num > DEPOSIT_LIMIT_MAX ||
    value === ''
  ) {
    return DEPOSIT_LIMIT_VALIDATION_MESSAGE
  }
  return ''
}
